import httpServices from 'services/http.service';
import { API_URLS } from 'config/constants';

export interface CreateCredentialsPayload {
  title: string;
  values: Record<string, string>;
}

export const createCredentials = (data: CreateCredentialsPayload) => (
  httpServices.post(API_URLS.CREDENTIALS.CREATE, data)
);

export const getCredentials = () => httpServices.get(API_URLS.CREDENTIALS.LIST);
